import React, { useState, useEffect, Fragment } from 'react';
import { Form, Button } from "react-bootstrap";
import { Route, Switch, useHistory } from "react-router-dom";  
import Product from '../Product';
import { CommonService } from '../../services';
import Pagination from "react-js-pagination";
import ProductDetailModal from '../../components/ProductDetailModal';
import EngineResult from '../engine/EngineResult';
import EngineDetail from '../engine/OldEngineDetails';

const SimpleSearch = ({pCustId}) => {
    const [marketId, setMarketId] = useState(process.env.MARINE_ID);
    const [custId, setCustId] = useState(pCustId);

    const [query, setQuery] = useState("");


    const itemsPerPage = 10;
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalItemsCount, setTotalItemsCount] = useState(1);

    const [products, setProducts] = useState([]);

    const [errorMessage, setErrorMessage] = useState();

    const onQueryChange = (value) => setQuery(value);
    const history = useHistory();

    const [modalShow, setModalShow] = useState(false);
    const [modalItemId, setmodalItemId] = useState(0);

    console.log("SimpleSearch");

    const openModal = (itemId) =>{
        setmodalItemId(itemId);
        setModalShow(true);
    }

    useEffect(() => {
        console.log("SimpleSearch.useEffect.Page");
        console.log("Query: ", query);
        if (query != ""){
            searchSimple();
            console.log("Query was not empty");
        }
        console.log("New page: " , page);
    },[page]);

    const goToPage = (page) => {
        setPage(page);
    }

    async function getProducts() {
        console.log("Getting Products");
        console.log("Page: ", page);
        await CommonService.performSimpleSearch(
            query, custId, itemsPerPage, page
        ).then(response => {
            if (response.status === 200 && response.data && response.data.SearchResults) {
                console.log("Response:", response);
                
                const data = response.data.SearchResults;
        
                setProducts(data);
                setLoading(false);
                //console.log("One item:", response.data.Data[0]);
                var searchSummary = response.data?.SearchFilterSummary;
                let totalItems = 0;
                console.log("SearchSummary:", searchSummary);

                if (searchSummary)
                {
                    totalItems = searchSummary?.totalRows ?? 0;
                }
                //const totalItems = response.data.Data[0] != null ? response.data.Data[0].totalRows : 0;
                
                console.log("Total Rows: ", totalItems);
                setTotalItemsCount(totalItems);
            }
        }).catch(function (error) {
            console.log(error);
        });
    }

    const searchSimple = () => {
        console.log("SimpleSearch.searchSimple");
        if (query.length <= 2){
            setErrorMessage("Query must be at least 3 characters long.");
            console.log("Caught short query");
        }
        else {
            setLoading(true);
            setProducts([]);
            getProducts();
            history.push("/results");
        }
    }

    const submitSimpleSearch = () => {
        console.log("SimpleSearch.submitSimpleSearch");
        //Submit the Search
        setErrorMessage();
        if (page != 1){
            setPage(1);
        }
        else if (query.length <= 2){
            setErrorMessage("Query must be at least 3 characters long.")
        }    
        else {
            searchSimple();
        }    
    }

    const resetSearch = () => {
        console.log("SimpleSearch.resetSearch");
        setQuery("");
       
        setPage(1);
        history.push("/");
    }

    return (
        <Fragment>
        
                <div className="detailed-search-form active  p-3">
                    <div className="col">
                            <div className="row pb-2">
                                <div className="col-lg-2"> <span className="form-title" style={{ fontSize: '15px', letterSpacing: '2px', lineHeight: '1', textTransform: 'uppercase', marginRight: '15px'}}>Find Your Parts</span></div>
                            </div>

                            <div className="row justify-content-md-start g-1">
                                <div className="col-lg-3">
                                    <Form.Control type="text" style={{ border: '2px solid #B6B6B6', borderRadius: '3px', verticalAlign: 'middle'}} name="query" placeholder="Search by Name" value={query} onChange={(e) => onQueryChange(e.target.value)} isInvalid={errorMessage != null ? true : false} />
                                    {errorMessage != null ? <Form.Control.Feedback type="invalid" style={{ display: 'inline', marginLeft: 5, marginTop: 2 }} >{errorMessage}</Form.Control.Feedback> : null}
                                </div>
                                <div className="col-lg-auto">
                                    <Button type="button" style={{ width: '123px', borderRadius: '24px', textAlign: 'center', marginLeft: '5px', marginRight: '5px' }} onClick={submitSimpleSearch}>SEARCH</Button>
                                    <Button type="button" style={{ width: '123px', borderRadius: '24px', textAlign: 'center', marginLeft: '5px', marginRight: '5px' }} variant="secondary" onClick={resetSearch}>RESET</Button>
                                </div>
                            </div>
                    </div>
                </div>
            

            <Switch>

                <Route exact path="/" render={props => (

                    <img src="https://media.sierraparts.com/WidgetBanner.png"></img>

                )} />
                <Route exact path="/results" render={props => (

                    <div className="search-results oem">
                                <Fragment>
                                <div className="oem-results engine-results results">
                                    {loading ? "" : 
                                        products.length > 0 ? products.map((product, index) =>
                                            product.itemRow!==""?
                                            <Product
                                                key={index}
                                                passedKey={index}
                                                description={product.description}
                                                categoryChild={product.categoryChild}
                                                categoryParent={product.categoryParent}
                                                saleItem={product.saleItem}
                                                productId={product.itemRow}
                                                imagePath={product.imagePath}
                                                marketId={marketId}
                                                custItem={product.custItem}
                                                pCustId={custId}
                                                showModal={(id) => openModal(id)}
                                                stockLevel={0}
                                                searchType={"simple"}
                                            />
                                            :
                                            <EngineResult
                                                key={index}
                                                horsePower={product.horsePower}
                                                brandName={product.brandName}
                                                modelNumber={product.modelNumber}
                                                engineId={product.engineId}
                                                startYear={product.startYear}
                                                stopYear={product.stopYear}
                                                // // horsepower={product.horsepower}
                                                stroke={product.stroke}
                                                cylinders={product.cylinders}
                                                startSerialNumber={product.serialNumberStart}
                                                stopSerialNumber={product.serialNumberStop}
                                                marketId={marketId}
                                                custId={custId}
                                                source="simple"
                                            />
                                        ) : <p className="lead p-3">No results found for this search.</p>
                                    }

                                        {totalItemsCount > itemsPerPage ?
                                            <div className="text-center mt-2">
                                                <Pagination
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    activePage={page}
                                                    itemsCountPerPage={itemsPerPage}
                                                    totalItemsCount={totalItemsCount}
                                                    pageRangeDisplayed={5}
                                                    onChange={goToPage}
                                                />
                                            </div>
                                            : null}
                                        <div className="">
                                        <ProductDetailModal modalItemId={modalItemId} show={modalShow} closeModal={() => setModalShow(false)} onHide={() => setModalShow(false)}></ProductDetailModal>
                                        </div>
                                    </div>
                                </Fragment>
                    </div>

                )} />
                <Route path="/searchEngine/:engineId" render={props => (
                    <EngineDetail {...props} pCustId={custId} />
                )} />
               
            </Switch>

          

        </Fragment>
    )
}

export default SimpleSearch;